import React, { useEffect, useState } from "react";
import "./UsefulLinks.css";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";

export default function UsefulLinks() {
  const [cities, setCities] = useState([]);

  // Load unique city names from Firestore
  useEffect(() => {
    async function fetchCities() {
      try {
        const snapshot = await getDocs(collection(db, "trails"));

        // Map ensures uniqueness (case-insensitive)
        const cityMap = new Map();

        snapshot.forEach((doc) => {
          const data = doc.data();
          const rawCity = data.location || data.city;

          if (rawCity && typeof rawCity === "string") {
            const clean = rawCity.trim();
            const key = clean.toLowerCase(); // ensures uniqueness even if case differs

            if (!cityMap.has(key)) {
              cityMap.set(key, clean);
            }
          }
        });

        setCities([...cityMap.values()]);
      } catch (err) {
        console.error("Error loading city list:", err);
      }
    }

    fetchCities();
  }, []);

  // Force all target="_blank" links to open in a new tab (fix for iPad/PWA)
  useEffect(() => {
    const links = document.querySelectorAll("a[target='_blank']");

    const handleClick = (e) => {
      e.preventDefault();
      window.open(e.currentTarget.href, "_blank", "noopener,noreferrer");
    };

    links.forEach((link) => {
      link.addEventListener("click", handleClick);
    });

    return () => {
      links.forEach((link) => {
        link.removeEventListener("click", handleClick);
      });
    };
  }, [cities]);

  return (
    <main className="useful-links-page">
      <section className="useful-header">
        <h1>Counties Our Trails Are In</h1>
        <p>Explore each County using search engines and online platforms.</p>
      </section>

      <section className="useful-list">
        {cities.map((city, index) => {
          const googleSearchURL = `https://www.google.com/search?q=${encodeURIComponent(city)}`;
          const googleMapsURL = `https://www.google.com/maps/search/${encodeURIComponent(city)}`;
          const youtubeURL = `https://www.youtube.com/results?search_query=${encodeURIComponent(city)}`;
          const wikipediaURL = `https://en.wikipedia.org/wiki/${encodeURIComponent(city)}`;
          const tiktokURL = `https://www.tiktok.com/search?q=${encodeURIComponent(city)}`;

          return (
            <article
              key={`city-${index}`}
              className="useful-section"
              style={{ backgroundImage: "url(/assets/images/banner.jpg)" }}
            >
              <div className="useful-section-overlay" />

              <div className="useful-section-content">
                <div className="useful-meta">
                  <span>Counties our Trails are in</span>
                </div>

                <h2>{city}</h2>

                <p className="useful-desc">Explore {city} online:</p>

                <div className="useful-footer button-grid">

                  {/* Google Search */}
                  <a
                    href={googleSearchURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="useful-button"
                  >
                    <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/google.svg" alt="" className="icon" />
                    Google Search
                  </a>

                  {/* Google Maps */}
                  <a
                    href={googleMapsURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="useful-button"
                  >
                    <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/googlemaps.svg" alt="" className="icon" />
                    Google Maps
                  </a>

                  {/* YouTube */}
                  <a
                    href={youtubeURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="useful-button youtube"
                  >
                    <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/youtube.svg" alt="" className="icon" />
                    YouTube
                  </a>

                  {/* Wikipedia */}
                  <a
                    href={wikipediaURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="useful-button wikipedia"
                  >
                    <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/wikipedia.svg" alt="" className="icon" />
                    Wikipedia
                  </a>

                  {/* TikTok */}
                  <a
                    href={tiktokURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="useful-button tiktok"
                  >
                    <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/tiktok.svg" alt="" className="icon" />
                    TikTok
                  </a>

                </div>
              </div>
            </article>
          );
        })}
      </section>
    </main>
  );
}
